import CustomFlag from './CustomFlag';

export default CustomFlag;
